const STORAGE_KEY = 'customerTypePreference';
const DEFAULT_TYPE = 'b2c';

const normalizeType = (type) => (type === 'b2b' ? 'b2b' : DEFAULT_TYPE);

const applyType = (type) => {
  const normalized = normalizeType(type);
  document.documentElement.dataset.customerType = normalized;
  document.body.classList.toggle('customer-type--b2b', normalized === 'b2b');
};

const syncToggles = (type) => {
  const normalized = normalizeType(type);

  document.querySelectorAll('[data-customer-type-toggle]').forEach((toggle) => {
    toggle.querySelectorAll('[data-customer-type]').forEach((button) => {
      const isActive = button.dataset.customerType === normalized;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    const select = toggle.querySelector('[data-customer-type-select]');
    if (select && select.value !== normalized) {
      select.value = normalized;
    }
  });
};

const persistType = (type) => {
  try {
    localStorage.setItem(STORAGE_KEY, type);
  } catch (error) {
    // Ignore persistence issues (private mode, etc.)
  }
};

const setType = (type) => {
  const normalized = normalizeType(type);
  persistType(normalized);
  applyType(normalized);
  syncToggles(normalized);
  window.dispatchEvent(new CustomEvent('customerTypeChange', { detail: { type: normalized } }));
};

const init = () => {
  let saved = null;
  try {
    saved = localStorage.getItem(STORAGE_KEY);
  } catch (error) {
    saved = null;
  }

  const initialType = normalizeType(saved);
  applyType(initialType);
  syncToggles(initialType);

  document.addEventListener('click', (event) => {
    const targetButton = event.target.closest('[data-customer-type]');
    if (!targetButton) return;

    const toggleWrapper = targetButton.closest('[data-customer-type-toggle]');
    if (!toggleWrapper) return;

    const selectedType = targetButton.dataset.customerType;
    setType(selectedType);
  });

  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-customer-type-select]');
    if (!select) return;

    const wrapper = select.closest('[data-customer-type-toggle]');
    if (!wrapper) return;

    setType(select.value);
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
